import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var TemplateType = /*#__PURE__*/function (TemplateType) {
  TemplateType[TemplateType["TEMPLATE_TYPE_GOLANG"] = 0] = "TEMPLATE_TYPE_GOLANG";
  TemplateType[TemplateType["TEMPLATE_TYPE_DJANGO"] = 1] = "TEMPLATE_TYPE_DJANGO";
  TemplateType[TemplateType["TEMPLATE_TYPE_GOLANG_TEXT"] = 2] = "TEMPLATE_TYPE_GOLANG_TEXT";
  return TemplateType;
}(TemplateType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class InflatedAccountGroupsAccountGroup {
  static fromProto(proto) {
    let m = new InflatedAccountGroupsAccountGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    return toReturn;
  }
}
class AccountGroupsHydrationOption {
  static fromProto(proto) {
    let m = new AccountGroupsHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedAppsApp {
  static fromProto(proto) {
    let m = new InflatedAppsApp();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = AppKey.fromProto(proto.appKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.editionName !== 'undefined') {
      toReturn['editionName'] = this.editionName;
    }
    return toReturn;
  }
}
class AppKey {
  static fromProto(proto) {
    let m = new AppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class InflatedBrandingBrandingApps {
  static fromProto(proto) {
    let m = new InflatedBrandingBrandingApps();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined') {
      toReturn['identifier'] = this.identifier;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class AppsHydrationOption {
  static fromProto(proto) {
    let m = new AppsHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKeys !== 'undefined') {
      toReturn['appKeys'] = this.appKeys;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedBrandingBrandingAssets {
  static fromProto(proto) {
    let m = new InflatedBrandingBrandingAssets();
    m = Object.assign(m, proto);
    if (proto.logoUrl) {
      m.logoUrl = InflatedBrandingBrandingAssetsUrl.fromProto(proto.logoUrl);
    }
    if (proto.shortcutIconUrl) {
      m.shortcutIconUrl = InflatedBrandingBrandingAssetsUrl.fromProto(proto.shortcutIconUrl);
    }
    if (proto.faviconUrl) {
      m.faviconUrl = InflatedBrandingBrandingAssetsUrl.fromProto(proto.faviconUrl);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.logoUrl !== 'undefined' && this.logoUrl !== null) {
      toReturn['logoUrl'] = 'toApiJson' in this.logoUrl ? this.logoUrl.toApiJson() : this.logoUrl;
    }
    if (typeof this.shortcutIconUrl !== 'undefined' && this.shortcutIconUrl !== null) {
      toReturn['shortcutIconUrl'] = 'toApiJson' in this.shortcutIconUrl ? this.shortcutIconUrl.toApiJson() : this.shortcutIconUrl;
    }
    if (typeof this.faviconUrl !== 'undefined' && this.faviconUrl !== null) {
      toReturn['faviconUrl'] = 'toApiJson' in this.faviconUrl ? this.faviconUrl.toApiJson() : this.faviconUrl;
    }
    return toReturn;
  }
}
class InflatedBrandingBranding {
  static fromProto(proto) {
    let m = new InflatedBrandingBranding();
    m = Object.assign(m, proto);
    if (proto.assets) {
      m.assets = InflatedBrandingBrandingAssets.fromProto(proto.assets);
    }
    if (proto.apps) {
      m.apps = InflatedBrandingBrandingApps.fromProto(proto.apps);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.assets !== 'undefined' && this.assets !== null) {
      toReturn['assets'] = 'toApiJson' in this.assets ? this.assets.toApiJson() : this.assets;
    }
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    return toReturn;
  }
}
class BrandingHydrationOption {
  static fromProto(proto) {
    let m = new BrandingHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class HydrationOptions {
  static fromProto(proto) {
    let m = new HydrationOptions();
    m = Object.assign(m, proto);
    if (proto.accountGroups) {
      m.accountGroups = AccountGroupsHydrationOption.fromProto(proto.accountGroups);
    }
    if (proto.apps) {
      m.apps = AppsHydrationOption.fromProto(proto.apps);
    }
    if (proto.packages) {
      m.packages = PackagesHydrationOption.fromProto(proto.packages);
    }
    if (proto.branding) {
      m.branding = BrandingHydrationOption.fromProto(proto.branding);
    }
    if (proto.users) {
      m.users = UsersHydrationOption.fromProto(proto.users);
    }
    if (proto.salesActivities) {
      m.salesActivities = SalesActivitiesHydrationOption.fromProto(proto.salesActivities);
    }
    if (proto.partnerConfig) {
      m.partnerConfig = PartnerConfigHydrationOption.fromProto(proto.partnerConfig);
    }
    if (proto.task) {
      m.task = TasksHydrationOption.fromProto(proto.task);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroups !== 'undefined' && this.accountGroups !== null) {
      toReturn['accountGroups'] = 'toApiJson' in this.accountGroups ? this.accountGroups.toApiJson() : this.accountGroups;
    }
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    if (typeof this.packages !== 'undefined' && this.packages !== null) {
      toReturn['packages'] = 'toApiJson' in this.packages ? this.packages.toApiJson() : this.packages;
    }
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    if (typeof this.salesActivities !== 'undefined' && this.salesActivities !== null) {
      toReturn['salesActivities'] = 'toApiJson' in this.salesActivities ? this.salesActivities.toApiJson() : this.salesActivities;
    }
    if (typeof this.partnerConfig !== 'undefined' && this.partnerConfig !== null) {
      toReturn['partnerConfig'] = 'toApiJson' in this.partnerConfig ? this.partnerConfig.toApiJson() : this.partnerConfig;
    }
    if (typeof this.task !== 'undefined' && this.task !== null) {
      toReturn['task'] = 'toApiJson' in this.task ? this.task.toApiJson() : this.task;
    }
    return toReturn;
  }
}
class InflatedAccountGroups {
  static fromProto(proto) {
    let m = new InflatedAccountGroups();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = proto.inflatedPropertyName.map(InflatedAccountGroupsAccountGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedApps {
  static fromProto(proto) {
    let m = new InflatedApps();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = proto.inflatedPropertyName.map(InflatedAppsApp.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedBranding {
  static fromProto(proto) {
    let m = new InflatedBranding();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = InflatedBrandingBranding.fromProto(proto.inflatedPropertyName);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedPacklages {
  static fromProto(proto) {
    let m = new InflatedPacklages();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = proto.inflatedPropertyName.map(InflatedPacklagesPackage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedSalesActivities {
  static fromProto(proto) {
    let m = new InflatedSalesActivities();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = proto.inflatedPropertyName.map(InflatedSalesActivitiesSalesActivity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedSalesConfig {
  static fromProto(proto) {
    let m = new InflatedSalesConfig();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = InflatedSalesConfigPartnerConfiguration.fromProto(proto.inflatedPropertyName);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedTasks {
  static fromProto(proto) {
    let m = new InflatedTasks();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = proto.inflatedPropertyName.map(InflatedTasksTask.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedUsers {
  static fromProto(proto) {
    let m = new InflatedUsers();
    m = Object.assign(m, proto);
    if (proto.inflatedPropertyName) {
      m.inflatedPropertyName = proto.inflatedPropertyName.map(InflatedUsersUser.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inflatedPropertyName !== 'undefined' && this.inflatedPropertyName !== null) {
      toReturn['inflatedPropertyName'] = 'toApiJson' in this.inflatedPropertyName ? this.inflatedPropertyName.toApiJson() : this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedPacklagesPackage {
  static fromProto(proto) {
    let m = new InflatedPacklagesPackage();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class PackagesHydrationOption {
  static fromProto(proto) {
    let m = new PackagesHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class PartnerConfigHydrationOption {
  static fromProto(proto) {
    let m = new PartnerConfigHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedSalesConfigPartnerConfiguration {
  static fromProto(proto) {
    let m = new InflatedSalesConfigPartnerConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.defaultCurrency !== 'undefined') {
      toReturn['defaultCurrency'] = this.defaultCurrency;
    }
    return toReturn;
  }
}
class SalesActivitiesHydrationOption {
  static fromProto(proto) {
    let m = new SalesActivitiesHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesActivityKeys !== 'undefined') {
      toReturn['salesActivityKeys'] = this.salesActivityKeys;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedSalesActivitiesSalesActivity {
  static fromProto(proto) {
    let m = new InflatedSalesActivitiesSalesActivity();
    m = Object.assign(m, proto);
    if (proto.salesActivityKey) {
      m.salesActivityKey = SalesActivityKey.fromProto(proto.salesActivityKey);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.lastEdited) {
      m.lastEdited = new Date(proto.lastEdited);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesActivityKey !== 'undefined' && this.salesActivityKey !== null) {
      toReturn['salesActivityKey'] = 'toApiJson' in this.salesActivityKey ? this.salesActivityKey.toApiJson() : this.salesActivityKey;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.lastEdited !== 'undefined' && this.lastEdited !== null) {
      toReturn['lastEdited'] = 'toApiJson' in this.lastEdited ? this.lastEdited.toApiJson() : this.lastEdited;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.salesStatus !== 'undefined') {
      toReturn['salesStatus'] = this.salesStatus;
    }
    if (typeof this.previousSalesStatus !== 'undefined') {
      toReturn['previousSalesStatus'] = this.previousSalesStatus;
    }
    if (typeof this.salespersonAction !== 'undefined') {
      toReturn['salespersonAction'] = this.salespersonAction;
    }
    if (typeof this.customActionName !== 'undefined') {
      toReturn['customActionName'] = this.customActionName;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.productPrice !== 'undefined') {
      toReturn['productPrice'] = this.productPrice;
    }
    if (typeof this.connected !== 'undefined') {
      toReturn['connected'] = this.connected;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.closedLostReason !== 'undefined') {
      toReturn['closedLostReason'] = this.closedLostReason;
    }
    if (typeof this.audioKey !== 'undefined') {
      toReturn['audioKey'] = this.audioKey;
    }
    if (typeof this.opportunityName !== 'undefined') {
      toReturn['opportunityName'] = this.opportunityName;
    }
    if (typeof this.audioUrl !== 'undefined') {
      toReturn['audioUrl'] = this.audioUrl;
    }
    if (typeof this.salesPersonFirstName !== 'undefined') {
      toReturn['salesPersonFirstName'] = this.salesPersonFirstName;
    }
    if (typeof this.salesPersonLastName !== 'undefined') {
      toReturn['salesPersonLastName'] = this.salesPersonLastName;
    }
    return toReturn;
  }
}
class SalesActivityKey {
  static fromProto(proto) {
    let m = new SalesActivityKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesActivityId !== 'undefined') {
      toReturn['salesActivityId'] = this.salesActivityId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class InflatedTasksTask {
  static fromProto(proto) {
    let m = new InflatedTasksTask();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class TaskKeys {
  static fromProto(proto) {
    let m = new TaskKeys();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPath !== 'undefined') {
      toReturn['parentPath'] = this.parentPath;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    return toReturn;
  }
}
class TasksHydrationOption {
  static fromProto(proto) {
    let m = new TasksHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskKeys !== 'undefined') {
      toReturn['taskKeys'] = this.taskKeys;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
class InflatedBrandingBrandingAssetsUrl {
  static fromProto(proto) {
    let m = new InflatedBrandingBrandingAssetsUrl();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.insecure !== 'undefined') {
      toReturn['insecure'] = this.insecure;
    }
    if (typeof this.secure !== 'undefined') {
      toReturn['secure'] = this.secure;
    }
    return toReturn;
  }
}
class InflatedUsersUser {
  static fromProto(proto) {
    let m = new InflatedUsersUser();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    return toReturn;
  }
}
class UsersHydrationOption {
  static fromProto(proto) {
    let m = new UsersHydrationOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIds !== 'undefined') {
      toReturn['userIds'] = this.userIds;
    }
    if (typeof this.inflatedPropertyName !== 'undefined') {
      toReturn['inflatedPropertyName'] = this.inflatedPropertyName;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class RawTemplate {
  static fromProto(proto) {
    let m = new RawTemplate();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$2(TemplateType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateContent !== 'undefined') {
      toReturn['templateContent'] = this.templateContent;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class Template {
  static fromProto(proto) {
    let m = new Template();
    m = Object.assign(m, proto);
    if (proto.hydrationOptions) {
      m.hydrationOptions = HydrationOptions.fromProto(proto.hydrationOptions);
    }
    if (proto.type) {
      m.type = enumStringToValue$2(TemplateType, proto.type);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.metadata !== 'undefined') {
      toReturn['metadata'] = this.metadata;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.hydrationOptions !== 'undefined' && this.hydrationOptions !== null) {
      toReturn['hydrationOptions'] = 'toApiJson' in this.hydrationOptions ? this.hydrationOptions.toApiJson() : this.hydrationOptions;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class TemplateIdentifier {
  static fromProto(proto) {
    let m = new TemplateIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SubstitutionParameter {
  static fromProto(proto) {
    let m = new SubstitutionParameter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.replacementTag !== 'undefined') {
      toReturn['replacementTag'] = this.replacementTag;
    }
    if (typeof this.requiredOptions !== 'undefined') {
      toReturn['requiredOptions'] = this.requiredOptions;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.isHtml !== 'undefined') {
      toReturn['isHtml'] = this.isHtml;
    }
    if (typeof this.isDeprecated !== 'undefined') {
      toReturn['isDeprecated'] = this.isDeprecated;
    }
    return toReturn;
  }
}
class SubstitutionParameterError {
  static fromProto(proto) {
    let m = new SubstitutionParameterError();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.replacementTag !== 'undefined') {
      toReturn['replacementTag'] = this.replacementTag;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class SubstitutionParameterOptions {
  static fromProto(proto) {
    let m = new SubstitutionParameterOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddTemplateLocaleRequest {
  static fromProto(proto) {
    let m = new AddTemplateLocaleRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class CreateTemplateRequest {
  static fromProto(proto) {
    let m = new CreateTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class DeleteTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class ListSubstitutionParametersRequestFilters {
  static fromProto(proto) {
    let m = new ListSubstitutionParametersRequestFilters();
    m = Object.assign(m, proto);
    if (proto.forRequiredOptions) {
      m.forRequiredOptions = SubstitutionParameterOptions.fromProto(proto.forRequiredOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeHtml !== 'undefined') {
      toReturn['includeHtml'] = this.includeHtml;
    }
    if (typeof this.includeDeprecated !== 'undefined') {
      toReturn['includeDeprecated'] = this.includeDeprecated;
    }
    if (typeof this.forRequiredOptions !== 'undefined' && this.forRequiredOptions !== null) {
      toReturn['forRequiredOptions'] = 'toApiJson' in this.forRequiredOptions ? this.forRequiredOptions.toApiJson() : this.forRequiredOptions;
    }
    return toReturn;
  }
}
class GetAllSubstitutionParametersRequest {
  static fromProto(proto) {
    let m = new GetAllSubstitutionParametersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetAllSubstitutionParametersResponse {
  static fromProto(proto) {
    let m = new GetAllSubstitutionParametersResponse();
    m = Object.assign(m, proto);
    if (proto.substitutionParameters) {
      m.substitutionParameters = proto.substitutionParameters.map(SubstitutionParameter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.substitutionParameters !== 'undefined' && this.substitutionParameters !== null) {
      toReturn['substitutionParameters'] = 'toApiJson' in this.substitutionParameters ? this.substitutionParameters.toApiJson() : this.substitutionParameters;
    }
    return toReturn;
  }
}
class GetMultiTemplateRequest {
  static fromProto(proto) {
    let m = new GetMultiTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.templateIds !== 'undefined') {
      toReturn['templateIds'] = this.templateIds;
    }
    return toReturn;
  }
}
class GetMultiTemplateResponse {
  static fromProto(proto) {
    let m = new GetMultiTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(GetMultiTemplateResponseGetOrError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    return toReturn;
  }
}
class GetMultiTemplateResponseGetOrError {
  static fromProto(proto) {
    let m = new GetMultiTemplateResponseGetOrError();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    if (typeof this.errorDescription !== 'undefined') {
      toReturn['errorDescription'] = this.errorDescription;
    }
    return toReturn;
  }
}
class GetTemplateRequest {
  static fromProto(proto) {
    let m = new GetTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetTemplateResponse {
  static fromProto(proto) {
    let m = new GetTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class ListSubstitutionParametersRequest {
  static fromProto(proto) {
    let m = new ListSubstitutionParametersRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSubstitutionParametersRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class ListSubstitutionParametersResponse {
  static fromProto(proto) {
    let m = new ListSubstitutionParametersResponse();
    m = Object.assign(m, proto);
    if (proto.substitutionParameters) {
      m.substitutionParameters = proto.substitutionParameters.map(SubstitutionParameter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.substitutionParameters !== 'undefined' && this.substitutionParameters !== null) {
      toReturn['substitutionParameters'] = 'toApiJson' in this.substitutionParameters ? this.substitutionParameters.toApiJson() : this.substitutionParameters;
    }
    return toReturn;
  }
}
class ListTemplateRequest {
  static fromProto(proto) {
    let m = new ListTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListTemplateResponse {
  static fromProto(proto) {
    let m = new ListTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(Template.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class RenderTemplateMultiRequestParameterizedTemplates {
  static fromProto(proto) {
    let m = new RenderTemplateMultiRequestParameterizedTemplates();
    m = Object.assign(m, proto);
    if (proto.substitutionParameterOptions) {
      m.substitutionParameterOptions = SubstitutionParameterOptions.fromProto(proto.substitutionParameterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.parameters !== 'undefined') {
      toReturn['parameters'] = this.parameters;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.substitutionParameterOptions !== 'undefined' && this.substitutionParameterOptions !== null) {
      toReturn['substitutionParameterOptions'] = 'toApiJson' in this.substitutionParameterOptions ? this.substitutionParameterOptions.toApiJson() : this.substitutionParameterOptions;
    }
    return toReturn;
  }
}
class RenderMultiRequestRender {
  static fromProto(proto) {
    let m = new RenderMultiRequestRender();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(TemplateType, proto.type);
    }
    if (proto.hydrationOptions) {
      m.hydrationOptions = HydrationOptions.fromProto(proto.hydrationOptions);
    }
    if (proto.substitutionParameterOptions) {
      m.substitutionParameterOptions = SubstitutionParameterOptions.fromProto(proto.substitutionParameterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateContent !== 'undefined') {
      toReturn['templateContent'] = this.templateContent;
    }
    if (typeof this.parameters !== 'undefined') {
      toReturn['parameters'] = this.parameters;
    }
    if (typeof this.errorOnMissingParam !== 'undefined') {
      toReturn['errorOnMissingParam'] = this.errorOnMissingParam;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.hydrationOptions !== 'undefined' && this.hydrationOptions !== null) {
      toReturn['hydrationOptions'] = 'toApiJson' in this.hydrationOptions ? this.hydrationOptions.toApiJson() : this.hydrationOptions;
    }
    if (typeof this.substitutionParameterOptions !== 'undefined' && this.substitutionParameterOptions !== null) {
      toReturn['substitutionParameterOptions'] = 'toApiJson' in this.substitutionParameterOptions ? this.substitutionParameterOptions.toApiJson() : this.substitutionParameterOptions;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.renderFakeData !== 'undefined') {
      toReturn['renderFakeData'] = this.renderFakeData;
    }
    return toReturn;
  }
}
class RenderMultiRequest {
  static fromProto(proto) {
    let m = new RenderMultiRequest();
    m = Object.assign(m, proto);
    if (proto.renderRequests) {
      m.renderRequests = proto.renderRequests.map(RenderMultiRequestRender.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.renderRequests !== 'undefined' && this.renderRequests !== null) {
      toReturn['renderRequests'] = 'toApiJson' in this.renderRequests ? this.renderRequests.toApiJson() : this.renderRequests;
    }
    return toReturn;
  }
}
class RenderMultiResponse {
  static fromProto(proto) {
    let m = new RenderMultiResponse();
    m = Object.assign(m, proto);
    if (proto.renders) {
      m.renders = proto.renders.map(RenderMultiResponseRenderOrError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.renders !== 'undefined' && this.renders !== null) {
      toReturn['renders'] = 'toApiJson' in this.renders ? this.renders.toApiJson() : this.renders;
    }
    return toReturn;
  }
}
class RenderMultiResponseRenderOrError {
  static fromProto(proto) {
    let m = new RenderMultiResponseRenderOrError();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.renderedTemplate !== 'undefined') {
      toReturn['renderedTemplate'] = this.renderedTemplate;
    }
    if (typeof this.errorDescription !== 'undefined') {
      toReturn['errorDescription'] = this.errorDescription;
    }
    return toReturn;
  }
}
class RenderRequest {
  static fromProto(proto) {
    let m = new RenderRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(TemplateType, proto.type);
    }
    if (proto.hydrationOptions) {
      m.hydrationOptions = HydrationOptions.fromProto(proto.hydrationOptions);
    }
    if (proto.substitutionParameterOptions) {
      m.substitutionParameterOptions = SubstitutionParameterOptions.fromProto(proto.substitutionParameterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateContent !== 'undefined') {
      toReturn['templateContent'] = this.templateContent;
    }
    if (typeof this.parameters !== 'undefined') {
      toReturn['parameters'] = this.parameters;
    }
    if (typeof this.errorOnMissingParam !== 'undefined') {
      toReturn['errorOnMissingParam'] = this.errorOnMissingParam;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.hydrationOptions !== 'undefined' && this.hydrationOptions !== null) {
      toReturn['hydrationOptions'] = 'toApiJson' in this.hydrationOptions ? this.hydrationOptions.toApiJson() : this.hydrationOptions;
    }
    if (typeof this.substitutionParameterOptions !== 'undefined' && this.substitutionParameterOptions !== null) {
      toReturn['substitutionParameterOptions'] = 'toApiJson' in this.substitutionParameterOptions ? this.substitutionParameterOptions.toApiJson() : this.substitutionParameterOptions;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.renderFakeData !== 'undefined') {
      toReturn['renderFakeData'] = this.renderFakeData;
    }
    return toReturn;
  }
}
class RenderResponse {
  static fromProto(proto) {
    let m = new RenderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.renderedTemplate !== 'undefined') {
      toReturn['renderedTemplate'] = this.renderedTemplate;
    }
    return toReturn;
  }
}
class RenderTemplateMultiRequest {
  static fromProto(proto) {
    let m = new RenderTemplateMultiRequest();
    m = Object.assign(m, proto);
    if (proto.templatesToRender) {
      m.templatesToRender = proto.templatesToRender.map(RenderTemplateMultiRequestParameterizedTemplates.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.templatesToRender !== 'undefined' && this.templatesToRender !== null) {
      toReturn['templatesToRender'] = 'toApiJson' in this.templatesToRender ? this.templatesToRender.toApiJson() : this.templatesToRender;
    }
    if (typeof this.errorOnMissingParam !== 'undefined') {
      toReturn['errorOnMissingParam'] = this.errorOnMissingParam;
    }
    return toReturn;
  }
}
class RenderTemplateRequest {
  static fromProto(proto) {
    let m = new RenderTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.substitutionParameterOptions) {
      m.substitutionParameterOptions = SubstitutionParameterOptions.fromProto(proto.substitutionParameterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.parameters !== 'undefined') {
      toReturn['parameters'] = this.parameters;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.errorOnMissingParam !== 'undefined') {
      toReturn['errorOnMissingParam'] = this.errorOnMissingParam;
    }
    if (typeof this.substitutionParameterOptions !== 'undefined' && this.substitutionParameterOptions !== null) {
      toReturn['substitutionParameterOptions'] = 'toApiJson' in this.substitutionParameterOptions ? this.substitutionParameterOptions.toApiJson() : this.substitutionParameterOptions;
    }
    return toReturn;
  }
}
class ReplaceTemplateRequest {
  static fromProto(proto) {
    let m = new ReplaceTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class UpdateTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = Template.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class VerifySubstitutionParametersRequest {
  static fromProto(proto) {
    let m = new VerifySubstitutionParametersRequest();
    m = Object.assign(m, proto);
    if (proto.rawTemplate) {
      m.rawTemplate = RawTemplate.fromProto(proto.rawTemplate);
    }
    if (proto.templateIdentifier) {
      m.templateIdentifier = TemplateIdentifier.fromProto(proto.templateIdentifier);
    }
    if (proto.substitutionParameterOptions) {
      m.substitutionParameterOptions = SubstitutionParameterOptions.fromProto(proto.substitutionParameterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rawTemplate !== 'undefined' && this.rawTemplate !== null) {
      toReturn['rawTemplate'] = 'toApiJson' in this.rawTemplate ? this.rawTemplate.toApiJson() : this.rawTemplate;
    }
    if (typeof this.templateIdentifier !== 'undefined' && this.templateIdentifier !== null) {
      toReturn['templateIdentifier'] = 'toApiJson' in this.templateIdentifier ? this.templateIdentifier.toApiJson() : this.templateIdentifier;
    }
    if (typeof this.substitutionParameterOptions !== 'undefined' && this.substitutionParameterOptions !== null) {
      toReturn['substitutionParameterOptions'] = 'toApiJson' in this.substitutionParameterOptions ? this.substitutionParameterOptions.toApiJson() : this.substitutionParameterOptions;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.parameters !== 'undefined') {
      toReturn['parameters'] = this.parameters;
    }
    return toReturn;
  }
}
class VerifySubstitutionParametersResponse {
  static fromProto(proto) {
    let m = new VerifySubstitutionParametersResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = proto.errors.map(SubstitutionParameterError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'templates-api.vendasta-local.com',
  'test': '',
  'demo': 'templates-api-demo.apigateway.co',
  'prod': 'templates-api-prod.apigateway.co',
  'production': 'templates-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TemplatesApiService = /*#__PURE__*/(() => {
  class TemplatesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTemplateResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiTemplateResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTemplateResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replace(r) {
      const request = r.toApiJson ? r : new ReplaceTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/Replace", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addTemplateLocale(r) {
      const request = r.toApiJson ? r : new AddTemplateLocaleRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/AddTemplateLocale", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    renderTemplate(r) {
      const request = r.toApiJson ? r : new RenderTemplateRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/RenderTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => RenderResponse.fromProto(resp)));
    }
    renderTemplateMulti(r) {
      const request = r.toApiJson ? r : new RenderTemplateMultiRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/RenderTemplateMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => RenderMultiResponse.fromProto(resp)));
    }
    render(r) {
      const request = r.toApiJson ? r : new RenderRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/Render", request.toApiJson(), this.apiOptions()).pipe(map(resp => RenderResponse.fromProto(resp)));
    }
    renderMulti(r) {
      const request = r.toApiJson ? r : new RenderMultiRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/RenderMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => RenderMultiResponse.fromProto(resp)));
    }
    getAllSubstitutionParameters(r) {
      const request = r.toApiJson ? r : new GetAllSubstitutionParametersRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/GetAllSubstitutionParameters", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAllSubstitutionParametersResponse.fromProto(resp)));
    }
    listSubstitutionParameters(r) {
      const request = r.toApiJson ? r : new ListSubstitutionParametersRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/ListSubstitutionParameters", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSubstitutionParametersResponse.fromProto(resp)));
    }
    verifySubstitutionParameters(r) {
      const request = r.toApiJson ? r : new VerifySubstitutionParametersRequest(r);
      return this.http.post(this._host + "/templates.v1.TemplatesService/VerifySubstitutionParameters", request.toApiJson(), this.apiOptions()).pipe(map(resp => VerifySubstitutionParametersResponse.fromProto(resp)));
    }
  }
  TemplatesApiService.ɵfac = function TemplatesApiService_Factory(t) {
    return new (t || TemplatesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TemplatesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesApiService,
    factory: TemplatesApiService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let TemplatesService = /*#__PURE__*/(() => {
  class TemplatesService {
    constructor(client) {
      this.client = client;
    }
    get(applicationId, templateId, locale) {
      return this.client.get({
        applicationId,
        templateId,
        locale
      }).pipe(map(resp => resp.template));
    }
    getMulti(applicationId, templateIds) {
      return this.client.getMulti({
        applicationId,
        templateIds
      }).pipe(map(resp => resp.templates));
    }
    create(applicationId, template) {
      return this.client.create({
        applicationId,
        template
      }).pipe(map(() => true));
    }
    update(applicationId, template) {
      return this.client.update({
        applicationId,
        template
      }).pipe(map(() => true));
    }
    /**
     * Render any text content using template hydration
     * @param templateContent The content to render - including substitution tags (Default is GoLang style, but can be overridden)
     * @param parameters Typically contains IDs used for hydration (e.g. partner ID, user ID) using keys of your choosing
     * @param subParamOpts Used for mapping the keys provided in `parameters` to the ones expected by templates microservice
     * @param templateType The templating engine to use.
     * @param locale The locale to use for localizable hydrations (e.g. dates, addresses) - optional
     * @param renderFakeData If true, will return fake data if real data cannot be rendered
     */
    render(templateContent, parameters, templateType = TemplateType.TEMPLATE_TYPE_GOLANG, subParamOpts, locale, errorOnMissingParam, options, renderFakeData) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const request = new RenderRequest({
        templateContent: templateContent,
        errorOnMissingParam: errorOnMissingParam,
        locale: locale,
        parameters: parameters,
        substitutionParameterOptions: subParamOpts,
        hydrationOptions: options,
        type: templateType,
        renderFakeData: renderFakeData
      });
      return this.client.render(request).pipe(map(resp => resp.renderedTemplate || ''));
    }
    renderTemplate(applicationId, templateId, parameters, locale, errorOnMissingParam) {
      return this.client.renderTemplate({
        applicationId: applicationId,
        templateId: templateId,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        parameters: parameters,
        locale: locale,
        errorOnMissingParam: errorOnMissingParam
      }).pipe(map(resp => resp.renderedTemplate || ''));
    }
    listSubstitutionParameters(filters) {
      return this.client.listSubstitutionParameters({
        filters: filters
      }).pipe(map(resp => resp.substitutionParameters));
    }
  }
  TemplatesService.ɵfac = function TemplatesService_Factory(t) {
    return new (t || TemplatesService)(i0.ɵɵinject(TemplatesApiService));
  };
  TemplatesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TemplatesService,
    factory: TemplatesService.ɵfac,
    providedIn: 'root'
  });
  return TemplatesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CreateTemplateRequest, DeleteTemplateRequest, GetMultiTemplateRequest, GetTemplateRequest, GetTemplateResponse, ListTemplateRequest, RenderMultiResponse, RenderRequest, RenderResponse, RenderTemplateMultiRequest, RenderTemplateRequest, SubstitutionParameter, Template, TemplateType, TemplatesApiService, TemplatesService, UpdateTemplateRequest };
